var map = {
	"./btn-back-hover.svg": "EPdU",
	"./btn-close-hover.svg": "BvBA",
	"./btn-delete-employee-hover.svg": "KMgH",
	"./btn-edit-status-hover.svg": "aCg6",
	"./btn-employee-hover.svg": "nekA",
	"./btn-enter-hover.svg": "H6Cd",
	"./btn-menu-hover.svg": "U/3z",
	"./btn-profile-hover.svg": "3uFq",
	"./btn-radio-button-selected-hover.svg": "fBZP",
	"./btn-radio-button-unselected-hover.svg": "nvK7",
	"./btn-settings-hover.svg": "bRyd",
	"./btn-upload-hover.svg": "mAcE",
	"./ic-menu-employee-hover.svg": "5iTN",
	"./ic-menu-facilities-hover.svg": "zIZt",
	"./ic-menu-immunity-passport-hover.svg": "ZeyJ",
	"./ic-menu-information-hover.svg": "InoV"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9RFn";